import { createAction } from 'redux-actions';
import axios from 'axios';

export const FETCH = 'levels/fetch';
export const FETCH_SUCCESS = 'levels/fetch_success';
export const FETCH_FAILURE = 'levels/fetch_failure';

export const fetchStart = createAction(FETCH);
export const fetchSuccess = createAction(FETCH_SUCCESS);
export const fetchFailure = createAction(FETCH_FAILURE);

export const fetchLevels = lang => dispatch => {
  // Only fetch if lang is set
  if (lang) {
    dispatch(fetchStart());

    return axios
      .get(`/api/levels/${ lang }`)
      .then(({data}) => dispatch(fetchSuccess(data)))
      .catch(err => dispatch(fetchFailure(err)));
  }
};


// WEBPACK FOOTER //
// ./src/reducers/levels/actions.js